// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageSection {
  /* flex: 1 1 75%; */
  /* padding: 0 2em; */
  height: 100%;
  /* height: 45rem; */
  /* margin-bottom: 5rem; */
}

.messageSection__title {
  font-size: 2rem;
  font-weight: 600;
  display: none;
  margin: 1rem 0 1rem 0;
}

.messageSection__container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-radius: 1.5rem;
  /* box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.04); */
  /* background: var(--clr-gray200); */
}

.messageSection__backBtn {
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 1em;
  background: var(--clr-primary);
  color: #fff;
  padding: 1em 1.25em;
  font-size: 0.8rem;
  cursor: pointer;
  margin-bottom: 1rem;
  display: block;
}

@media (min-width: 992px) {
  .messageSection {
    margin-bottom: 3rem;
  }

  .messageSection__backBtn {
    display: none;
  }

  .messageSection__container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .messageSection__title {
    display: flex;
  }
}

@media (min-width: 1200px) {
  .messageSection {
    height: 45rem;
    margin-bottom: 7rem;
  }
  .messageSection__container {
    display: flex;
    flex-direction: row;
    border-radius: 2em;
    overflow: hidden;
    box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.04);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MessageComponents/MessageSection/MessageSection.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sDAAsD;EACtD,oCAAoC;AACtC;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gDAAgD;EAClD;AACF","sourcesContent":[".messageSection {\n  /* flex: 1 1 75%; */\n  /* padding: 0 2em; */\n  height: 100%;\n  /* height: 45rem; */\n  /* margin-bottom: 5rem; */\n}\n\n.messageSection__title {\n  font-size: 2rem;\n  font-weight: 600;\n  display: none;\n  margin: 1rem 0 1rem 0;\n}\n\n.messageSection__container {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  border-radius: 1.5rem;\n  /* box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.04); */\n  /* background: var(--clr-gray200); */\n}\n\n.messageSection__backBtn {\n  width: fit-content;\n  border-radius: 1em;\n  background: var(--clr-primary);\n  color: #fff;\n  padding: 1em 1.25em;\n  font-size: 0.8rem;\n  cursor: pointer;\n  margin-bottom: 1rem;\n  display: block;\n}\n\n@media (min-width: 992px) {\n  .messageSection {\n    margin-bottom: 3rem;\n  }\n\n  .messageSection__backBtn {\n    display: none;\n  }\n\n  .messageSection__container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .messageSection__title {\n    display: flex;\n  }\n}\n\n@media (min-width: 1200px) {\n  .messageSection {\n    height: 45rem;\n    margin-bottom: 7rem;\n  }\n  .messageSection__container {\n    display: flex;\n    flex-direction: row;\n    border-radius: 2em;\n    overflow: hidden;\n    box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.04);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
